import { useQuery } from "react-query";
import {
	fetchTicketLabel,
	fetchTicketLabels,
} from "../queries/ticket_labels.queries";

export const useTicketLabels = ({ all }: { all?: boolean }) => {
	return useQuery(["ticket_labels"], () => {
		try {
			return fetchTicketLabels({ all });
		} catch (err) {
			return null;
		}
	});
};

export const useTicketLabel = (id: number | string) => {
	const query = useQuery(["ticket_labels", id], () => {
		try {
			return fetchTicketLabel(id);
		} catch (err) {
			return null;
		}
	});
	return query?.data;
};
